export * from './medrecord-environment.interface';
